import { AggregationType } from "../../../../model/transaction";

export function formatPeriodLabel(period: string, aggregationType: AggregationType | undefined): string {
	const d = new Date(period);
	if (isNaN(d.getTime())) return period;
	switch (aggregationType) {
		case AggregationType.MONTH:
			return d.toLocaleString("default", { month: "short", year: "numeric" });
		case AggregationType.DAY:
			return d.toLocaleString("default", { month: "short", day: "2-digit" });
		case AggregationType.HOUR:
			return d.toLocaleString("default", { month: "short", day: "2-digit", hour: "2-digit", minute: "2-digit" });
		default:
			return d.toLocaleString("default", { month: "short", day: "2-digit" });
	}
}

export function getPeriodKey(periodIso: string, aggregationType: AggregationType): string {
	const d = new Date(periodIso);
	if (isNaN(d.getTime())) return periodIso;
	const y = d.getFullYear();
	const m = String(d.getMonth() + 1).padStart(2, "0");
	const day = String(d.getDate()).padStart(2, "0");
	const h = String(d.getHours()).padStart(2, "0");
	switch (aggregationType) {
		case AggregationType.MONTH:
			return `${y}-${m}`;
		case AggregationType.DAY:
			return `${y}-${m}-${day}`;
		case AggregationType.HOUR:
			return `${y}-${m}-${day}-${h}`;
		default:
			return `${y}-${m}-${day}`;
	}
}

export function getPeriodKeyFromDate(d: Date, aggregationType: AggregationType): string {
	const y = d.getFullYear();
	const m = String(d.getMonth() + 1).padStart(2, "0");
	const day = String(d.getDate()).padStart(2, "0");
	const h = String(d.getHours()).padStart(2, "0");
	switch (aggregationType) {
		case AggregationType.MONTH:
			return `${y}-${m}`;
		case AggregationType.DAY:
			return `${y}-${m}-${day}`;
		case AggregationType.HOUR:
			return `${y}-${m}-${day}-${h}`;
		default:
			return `${y}-${m}-${day}`;
	}
}

export function getPeriodsBetween(fromDate: Date, toDate: Date, aggregationType: AggregationType): { key: string; periodIso: string }[] {
	const result: { key: string; periodIso: string }[] = [];
	const current = new Date(fromDate.getTime());
	const end = new Date(toDate.getTime());
	// Normalize to start of period for comparison
	current.setSeconds(0, 0);
	end.setSeconds(0, 0);
	if (aggregationType === AggregationType.DAY) {
		current.setHours(0, 0, 0, 0);
		end.setHours(0, 0, 0, 0);
	} else if (aggregationType === AggregationType.MONTH) {
		current.setDate(1);
		current.setHours(0, 0, 0, 0);
		end.setDate(1);
		end.setHours(0, 0, 0, 0);
	} else if (aggregationType === AggregationType.HOUR) {
		current.setMinutes(0, 0, 0);
		end.setMinutes(0, 0, 0);
	}

	while (current.getTime() <= end.getTime()) {
		result.push({ key: getPeriodKeyFromDate(current, aggregationType), periodIso: current.toISOString() });
		switch (aggregationType) {
			case AggregationType.MONTH:
				current.setMonth(current.getMonth() + 1);
				break;
			case AggregationType.DAY:
				current.setDate(current.getDate() + 1);
				break;
			case AggregationType.HOUR:
				current.setHours(current.getHours() + 1);
				break;
			default:
				current.setDate(current.getDate() + 1);
		}
	}
	return result;
}
